<template>
    <div class="distribution">
        <el-tabs v-model="activeName">
            <el-tab-pane label="推广员" name="ExtensionAgent">
                <ExtensionAgent :innerid="innerid"></ExtensionAgent>
            </el-tab-pane>
            <el-tab-pane label="商品设置" name="CommoditySetting">
                <CommoditySetting :innerid="innerid"></CommoditySetting>
            </el-tab-pane>
            <el-tab-pane label="推广记录" name="GeneralizeRecord">
                <GeneralizeRecord :innerid="innerid"></GeneralizeRecord>
            </el-tab-pane>
            <el-tab-pane label="买家绑定查询" name="BuyerBindingCheck">
                <BuyerBindingCheck :innerid="innerid"></BuyerBindingCheck>
            </el-tab-pane>
            <el-tab-pane label="业绩统计" name="PerformanceStatistics">
                <PerformanceStatistics :innerid="innerid"></PerformanceStatistics>
            </el-tab-pane>
            <el-tab-pane label="分销设置" name="DistributionSetting">
                <DistributionSetting :innerid="innerid"></DistributionSetting>
            </el-tab-pane>
        </el-tabs>
        
    </div>
</template>
<script>
import BuyerBindingCheck from './BuyerBindingCheck'
import CommoditySetting from './CommoditySetting'
import DistributionSetting from './DistributionSetting'
import ExtensionAgent from './ExtensionAgent'
import GeneralizeRecord from './GeneralizeRecord'
import PerformanceStatistics from './PerformanceStatistics'
export default {
    name: 'distribution',
    data() {
        return {
activeName: 'ExtensionAgent',
        }
    },
    methods: {
    },
    props: ['innerid'],
    components: {
        BuyerBindingCheck, CommoditySetting, DistributionSetting, ExtensionAgent, GeneralizeRecord, PerformanceStatistics
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .distribution{
        min-height: 618px;
    }
</style>